import { ComponentProps } from 'react'

import { Pressable, colors } from '@zet/design-system'
import { Button } from '@zet/design-system/button'
import { Stack, XStack } from '@zet/design-system/layout'
import { Stepper } from '@zet/design-system/stepper'
import CheckBox from '@zet/design-system/svg/CheckBox'
import CheckBoxTickFilled from '@zet/design-system/svg/CheckBoxTickFilled'
import { Control } from 'react-hook-form'

import { ConsentContent } from '../common/consentContent/index.web'
import TermsAndConditions from '../otp/termsAndConditions'
import FormButton from './formButton'
import NonFormButton from './nonFormButton'

type FooterType = {
  step?: {
    total: number
    current: number
  }
  buttonProps?: ComponentProps<typeof Button>
  showTNC?: boolean
  control: Control
  isForm?: boolean
  consents?: string[]
  userConsents?: boolean[]
  setUserConsents?: () => void
}
const Footer = ({
  step,
  buttonProps,
  showTNC,
  control,
  isForm,
  consents,
  userConsents,
  setUserConsents,
}: FooterType) => {
  const Button = isForm ? (
    <FormButton control={control} buttonProps={buttonProps} step={step} />
  ) : (
    <NonFormButton buttonProps={buttonProps} step={step} />
  )

  const handleChange = (index: number, value: boolean): void => {
    setUserConsents((prevArray: boolean[]) => {
      const newArray = [...prevArray]
      newArray[index] = value
      return newArray
    })
  }

  return (
    <Stack>
      {showTNC && <TermsAndConditions />}
      <Stack className="border-grays-40 items-center border-t p-2">
        {!!consents &&
          userConsents &&
          consents?.map((consent, index) => {
            return (
              <XStack className="py-2" key={index}>
                {userConsents[index] ? (
                  <Pressable onPress={() => handleChange(index, false)}>
                    <CheckBoxTickFilled color={colors.primary[100]} size={18} />
                  </Pressable>
                ) : (
                  <Pressable onPress={() => handleChange(index, true)}>
                    <CheckBox color={colors.primary[100]} size={18} />
                  </Pressable>
                )}
                <Stack className="ml-1 flex-1">
                  <ConsentContent consentData={consent} index={index} />
                </Stack>
              </XStack>
            )
          })}
        <XStack className="w-full">
          {!!step && (
            <Stack className="mr-5" style={{ flex: 5 }}>
              <Stepper
                intent="warning"
                maxCount={step.total}
                minCount={step.current}
                className="w-full"
              />
            </Stack>
          )}

          <Stack style={{ flex: 4 }}>{Button}</Stack>
        </XStack>
      </Stack>
    </Stack>
  )
}
export default Footer
